import { Component, OnInit } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { MyProfileModel } from 'src/shared/model/UserProfile';

import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { Subject } from 'rxjs';
import { DynamicModalService } from '../ui-components/dynamic-modals/dynamic-modal.service';
import { JqueryDialogService } from '../ui-components/jquery-dialog/jquery-dialog.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EnUserTypes } from '../security/page-name.enum';
import { DictionaryService } from '../../shared/service/dictionary.service';
import { finalize } from 'rxjs/operators';
import {getErrorMessageText} from '../helper';


interface LinkAccountDto {
  WpUserNum?: number;
  RecordType?: string;
  AccountNumber?: number;
  Pin?: string;
}

@Component({
    selector: 'app-edit-profile',
    templateUrl: './link-account-modal.component.html',
    styleUrls: ['./link-account-modal.component.scss'],
    standalone: false
})
export class LinkAccountModalComponent implements OnInit {
  userProfileEntity: MyProfileModel = new MyProfileModel();

  display = false;
  alertMessage: string;
  clientCode: string;
  logoImageUrl: string;
  public subjectOnClose: Subject<any>;
  userType: string;
  form: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    pin: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    public rest: RestService,
    public authService: AuthServiceCustom,
    private dynamicModalService: DynamicModalService,
    private ngxService: NgxUiLoaderService,
    private jqueryDialogService: JqueryDialogService,
    private abstractDataProvider: AbstractDataProvider,
    private dictionaryService: DictionaryService) {
  }


  ngOnInit() {
    this.clientCode = this.authService.clientCode;
    this.userType = this.authService.UserType;
  }

  onClosePopup() {
    this.display = false;
  }

  getUserTypeTitle(userType: string): string {
    switch (userType) {
      case EnUserTypes.Investor:
        return this.dictionaryService.localize('INVESTOR');
      case EnUserTypes.Broker:
        return this.dictionaryService.localize('BROKER');
      case EnUserTypes.Custodian:
        return this.dictionaryService.localize('CUSTODIAN');
      case EnUserTypes.Rep:
        return this.dictionaryService.localize('REP');
      case EnUserTypes.Territory:
        return this.dictionaryService.localize('TERRITORY');
      case EnUserTypes.User:
        return this.dictionaryService.localize('USER');
      case EnUserTypes.DupMail:
        return this.dictionaryService.localize('DUPMAIL');
    }
  }


  submit(): void {

    this.form.updateValueAndValidity();

    if (this.form.invalid) {
      return;
    }

    // TODO: fix this code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }

    this.ngxService.start();
    const dto = {
      WpUserNum: parseInt(this.authService.currentUserProfileEntity.WpUserNum, 10),
      RecordType: this.authService.UserType,
      AccountNumber: parseInt(this.form.get('id').value, 10),
      Pin: this.form.get('pin').value
    } as LinkAccountDto;

    this.abstractDataProvider.postData(dto, 'api/Accounts/AddLinkedAccount').pipe(
      finalize(() => this.ngxService.stop())
    ).subscribe(() => {
      this.close(true);
    }, error => {
      this.display = true;
      this.alertMessage =  getErrorMessageText(error, error.error);
    });
  }

  cancel() {
    this.close(false);
  }

  close(result: any = null) {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.subjectOnClose.next(result);
    }
    this.dynamicModalService.subject.next(null);
  }
}
